// utils
import axiosInstance from '../../utils/axios';

const getSupportStatus = async () => {
  try {
    const response = await axiosInstance({
      method: 'get',
      url: `/lms_chat/api/partner/support/status`,
    });
    const res = await response.data;
    return res;
  } catch (error) {
    console.log(error);

    throw new Error(JSON.stringify(error));
  }
};

export { getSupportStatus };
